import { Component, Input } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import './string.extensions';


export interface ButtonConfig {
  buttonText?: string
  buttonIconClass?: string
  buttonClass?: string
  buttonDisable?: boolean
  buttonVisible?: any
  row?: object
  customImage?: string  // Add support for custom image

  clicked($event: Event, param?: any): Promise<boolean> | boolean
}

@Component({
  selector: 'btn-cell-renderer1',
  template: `
    <div ><div style="float:left" class="p-1" *ngFor="let conf of buttonConfig"> 
      <button type="button" *ngIf="isVisible(conf)"
              [class]="'btn bg-danger-custom btn-icon '+conf.buttonClass" 
              (click)="conf.clicked($event, params)">
        {{conf.buttonText}}
        <img *ngIf="conf.customImage" [src]="conf.customImage" style="width: 16px; height: 16px; vertical-align: middle;" />
        <i *ngIf="!conf.customImage" class="feather" [className]="'feather '+conf.buttonIconClass"></i>
      </button>
    </div></div>
  `,
})
export class BtnCellRenderer1 implements ICellRendererAngularComp {
  @Input() public buttonConfig: ButtonConfig[]
  public params: any;

  agInit(params: ICellRendererParams): void {
    // console.log(params);
    this.params = params;
    this.buttonConfig = params.colDef?.cellRendererParams;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    // throw new Error("Method not implemented.");
    return true;
  }

  // btnClickedHandler($event: Event) {
  //   this.params.clicked(this.params.value);
  // }
  checkCondition(visibleConf: any = {}): boolean {
    let cond = false;
    let keylist = Object.keys(visibleConf)
    if (keylist.length == 0) { return true }
    keylist.forEach((k) => {
      if (this.params.data[k] != visibleConf[k]) {
        cond = true
        return false;
      }
      return true;
    })
    console.log(cond)
    return cond;
  }

  run(condition: string) {
    let e = eval(condition.interpolate(this.params.data));

    return e;
  }

  isButtonVisible() {
    return this.params.data.reviewFlag !== false
  }

  isVisible(conf: any): boolean {
  if (typeof conf.buttonVisible === 'function') {
    return conf.buttonVisible(this.params);
  }

  // Existing behavior remains unchanged
  return conf.buttonVisible || this.isButtonVisible();
  }
}
